export default "__VITE_ASSET__116d43cd__"